import confetti from 'canvas-confetti';
import { useEffect, useRef } from 'react';

const Confetti = () => {
  const canvasRef = useRef();

  useEffect(() => {
    const myConfetti = confetti.create(canvasRef.current, {
      resize: true,
      useWorker: true,
    });

    const origin =
      window.innerWidth > 768 ? { x: 0.75, y: 0.4 } : { x: 0.5, y: 0.5 };

    const angle = window.innerWidth > 768 ? 120 : 90;

    myConfetti({
      particleCount: 300,
      spread: 100,
      origin,
      angle,
    });
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        inset: 0,
        width: '100vw',
        height: '100vh',
        zIndex: 999999,
        pointerEvents: 'none',
      }}
    ></canvas>
  );
};

export default Confetti;
